import React from "react";
import { useState } from 'react'
import RedeeemShareDialog from './RedeemShareDialog'
import RedeemShareQuery from "./RedeemShareQuery";
import { isNil, isEmpty } from 'lodash'
import ApiUser from 'models/data/api/ApiUser'

export default ({ story, paywalled, currentUserIsNotSubscribed, storyId, sharedStoryLinkId }) => {

    const [redeemShareDialogOpen, setRedeemShareDialogOpen] = useState(true);
    const shouldShowDialog = currentUserIsNotSubscribed && !isEmpty(sharedStoryLinkId);
    
    return (
		<RedeemShareQuery sharedStoryLinkId={sharedStoryLinkId}>
			{({ shareLinkCreator }) => (
				<RedeeemShareDialog
					storyId={storyId}
					story={story}
					paywalled={paywalled}
					sharedStoryLinkId={sharedStoryLinkId}
					shareLinkCreatorEmail={ApiUser.email(shareLinkCreator)}
					shareLinkCreatorName={`${ApiUser.firstName(
						shareLinkCreator
					)} ${ApiUser.lastName(shareLinkCreator)}`}
					open={!isNil(shareLinkCreator) && shouldShowDialog && redeemShareDialogOpen}
					onClose={() => setRedeemShareDialogOpen(false)}
				/>
			)}
		</RedeemShareQuery>
	);
}
